import { render } from "./ScriptDetailPage.vue?vue&type=template&id=0c9010cc&ts=true"
import script from "./ScriptDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScriptDetailPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/script/ScriptDetailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c9010cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c9010cc', __exports__)) {
    api.reload('0c9010cc', __exports__)
  }
  
  module.hot.accept("./ScriptDetailPage.vue?vue&type=template&id=0c9010cc&ts=true", () => {
    api.rerender('0c9010cc', render)
  })

}


export default __exports__